import React from 'react';

import classnames from 'classnames';

import styles from './CloseSVG.module.css';

const CloseSVG = ({ className }) => (
    <svg viewBox="0 0 20 20" className={classnames(styles.svg, className)}>
        <path
            d="M1.5 1.5l16.568 16.568m-16.556.42L18.478 1.522"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);

export default CloseSVG;
